import { SVGProps } from "react"

const Calendar3Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="1.73047"
      width="14.7692"
      height="14.7692"
      rx="2"
      stroke={props.color || "#687079"}
    />
    <path d="M0.5 5.83213H15.2692" stroke={props.color || "#687079"} strokeLinejoin="round" />
    <path
      d="M11.5763 0.5L11.5763 2.96154"
      stroke={props.color || "#687079"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.19151 0.5L4.19151 2.96154"
      stroke={props.color || "#687079"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.37109 9.11709H4.19161"
      stroke={props.color || "#687079"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.47461 9.11709H8.29512"
      stroke={props.color || "#687079"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5762 9.11709H12.3967"
      stroke={props.color || "#687079"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.37109 12.3983H4.19161"
      stroke={props.color || "#687079"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.47461 12.3983H8.29512"
      stroke={props.color || "#687079"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5762 12.3983H12.3967"
      stroke={props.color || "#687079"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Calendar3Icon
